import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://soaxjsjkwtrnnewfjjyx.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvYXhqc2prd3Rybm5ld2Zqanl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEzNjQwMzYsImV4cCI6MjA4Njk0MDAzNn0.M6MMN_LPtBKZktXoZsuBTH1ItLg2Z8c-OQUSQXVSeo8'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})